import { MatDialogConfig } from '@angular/material/dialog';
import { MatBottomSheetConfig } from '@angular/material/bottom-sheet';

/**
 * Global default options applied to every {@link MatDialog} via
 * `MAT_DIALOG_DEFAULT_OPTIONS`.
 *
 * Standardized UX:
 * - `disableClose: true`  -> a backdrop click never closes the dialog.
 * - `autoFocus: false`    -> focus does not jump to the first input automatically.
 * - `restoreFocus: true`  -> focus returns to the trigger element on close (a11y).
 *
 * Closing is funneled through either the ESC key (see
 * `DialogEscCloseService`, which restores ESC-to-close globally despite
 * `disableClose`) or an explicit close button (`DialogHeaderCloseComponent`).
 */
export const APP_DIALOG_DEFAULTS: MatDialogConfig = {
  disableClose: true,
  autoFocus: false,
  restoreFocus: true,
  hasBackdrop: true,
};

/**
 * Global default options applied to every {@link MatBottomSheet} via
 * `MAT_BOTTOM_SHEET_DEFAULT_OPTIONS`.
 *
 * Note: `disableClose` is intentionally NOT enabled globally for bottom sheets.
 * Many lightweight menu/action sheets are dismissed by a backdrop tap, and
 * flipping that globally would trap users. Standardized modal sheets opt into
 * `disableClose` + ESC handling through `BottomSheetFacadeService.open()`.
 */
export const APP_BOTTOM_SHEET_DEFAULTS: MatBottomSheetConfig = {
  autoFocus: false,
  restoreFocus: true,
};
